import classNames from 'classnames';
import { SectionContainer } from 'components/section-container.js';
import { useLayoutHeaderSections } from 'layout/sections/use-layout-header-sections.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { filterPrimaryConfig } from 'page/layout-areas.js';
import * as React from 'react';
import { reduxInitialStateLayout } from 'redux-state/layout/reducer.js';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { PW_MAP_CONTAINER } from 'utilities/consts/variable-types.js';

interface IStateProps {
  name?: string;
  data?: ILayoutConfig;
}

/**
 * This is a component as we do not want headers to update and re-render child components
 * and as a result all the modules within the map layout
 */
export const MapHeaders = ({
  data,
  children,
}: /** searchBarOffset increases when searchbar is displaying */ IStateProps & { children: JSX.Element }) => {
  const columnLayout = React.useContext(ColumnLayoutContext);
  const { primary } = data ?? reduxInitialStateLayout().screen.layout;

  const filteredPrimaryConfig = React.useMemo(
    () => filterPrimaryConfig(primary?.slots, columnLayout),
    [primary.slots, columnLayout],
  );

  const headers = useLayoutHeaderSections({
    config: data ?? reduxInitialStateLayout().screen.layout,
    primary: filteredPrimaryConfig,
  });

  const gridClasses = classNames(
    'Grid Grid--withGutter Grid--map u-pL-xs u-pR-xs',
    { 'u-pT-responsive': !headers.length || columnLayout !== '1-column' },
    { 'u-pB-responsive': columnLayout !== '1-column' },
  );

  return (
    <>
      {headers}
      <SectionContainer
        dataModule="map-layout"
        className="u-lg-posRelative u-flex u-flexGrow1"
        contentClassName="Container-inner Container-content"
        fill={columnLayout === '1-column' ? 'gradient' : undefined}
      >
        <div className={gridClasses} data-testid={PW_MAP_CONTAINER}>
          {children}
        </div>
      </SectionContainer>
    </>
  );
};
